import { library } from '@fortawesome/fontawesome-svg-core';
import { fab } from '@fortawesome/free-brands-svg-icons';
import {
  faCheckSquare,
  faCoffee,
  faCheck,
  faShoePrints,
  faTrashAlt,
  faBoxOpen,
  faUser,
  faTag,
  faBullseye,
  faClipboardCheck,
  faBalanceScaleRight,
  faComment,
  faCalendarAlt,
  faFolder
} from '@fortawesome/free-solid-svg-icons';

// TODO Manage imgs vs fontawesomeicon react objects etc here in the icons folder

const initializeIcons = () => {
  library.add(
    fab,
    faCheckSquare,
    faCoffee,
    faCheck,
    faShoePrints,
    faTrashAlt,
    faBoxOpen,
    faUser,
    faTag,
    faBullseye,
    faClipboardCheck,
    faBalanceScaleRight,
    faComment,
    faCalendarAlt,
    faFolder
  );
};

export default initializeIcons;
